import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ShieldAlert, Info, ChevronRight, CheckCircle2 } from "lucide-react";
import { studio } from "@/lib/studioApi";

const LEVELS = {
  danger: { icon: ShieldAlert, ring: "border-[#E2E7F7] bg-white shadow-[inset_3px_0_0_#E11D48]", icon_cls: "bg-rose-50 text-rose-600", text: "text-[#0F2645]" },
  warning: { icon: AlertTriangle, ring: "border-[#E2E7F7] bg-white shadow-[inset_3px_0_0_#F59E0B]", icon_cls: "bg-amber-50 text-amber-600", text: "text-[#0F2645]" },
  info: { icon: Info, ring: "border-[#E2E7F7] bg-white shadow-[inset_3px_0_0_#3A5CC8]", icon_cls: "bg-[#EEF1FC] text-[#3A5CC8]", text: "text-[#0F2645]" },
};

// Alertes intelligentes du tableau de bord : assurance, profil, Peppol, devis sans réponse, factures en retard, essai.
export const AlertsPanel = () => {
  const [data, setData] = useState(null);
  useEffect(() => { studio.get("/alerts").then(({ data: d }) => setData(d)).catch(() => setData({ alerts: [] })); }, []);
  if (!data) return null;
  if (!data.alerts.length) {
    return (
      <div data-testid="cockpit-alerts-empty" className="dv-card-in mt-4 flex items-center gap-3 rounded-xl border border-[#E2E7F7] bg-white px-4 py-3 text-sm font-medium text-emerald-700 shadow-[inset_3px_0_0_#059669]">
        <CheckCircle2 className="h-4 w-4" /> Tout est en ordre : aucune action urgente aujourd'hui.
      </div>
    );
  }
  return (
    <section data-testid="cockpit-alerts" className="mt-4">
      <p className="text-[11px] font-semibold uppercase tracking-[0.1em] text-[#93A0BC]">À traiter · {data.count}</p>
      <div className="mt-2 grid gap-2 lg:grid-cols-2">
        {data.alerts.map((a, i) => {
          const L = LEVELS[a.level] || LEVELS.info;
          return (
            <Link
              key={a.key}
              to={a.to}
              data-testid={`alert-${a.key}`}
              style={{ animationDelay: `${i * 50}ms` }}
              className={`dv-card-in group flex items-start gap-3 rounded-xl border px-4 py-3 transition-colors duration-150 hover:border-[#C9D4F4] ${L.ring}`}
            >
              <span className={`mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${L.icon_cls}`}><L.icon className="h-4 w-4" /></span>
              <span className="min-w-0 flex-1">
                <span className={`block text-sm font-bold ${L.text}`}>{a.title}</span>
                <span className="mt-0.5 block text-xs leading-relaxed text-[#5C6A87]">{a.hint}</span>
              </span>
              <span className="mt-1 inline-flex shrink-0 items-center gap-1 text-xs font-bold text-[#3A5CC8]">{a.cta} <ChevronRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" /></span>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
